import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import rules from "../../../utils/rules";
import telematicsService from "../../../api/telematics.service";
export default {
  name: "service-template-management",
  components: { pageheader },
  data() {
    return {
      input: {},
      valid: true,
      rules: rules,
      isCreateserviceTemplate: false,
      name: "",
      description: "",
      triggerTypeList: ["Calendar", "Hours", "Miles"],
      selectedTriggerType: "",
      calendarTypeList: ["Yearly", "Quarterly", "Monthly"],
      selectedCalendarType: "",
      hours: "",
      miles: "",
      generateWorkOrderTicket: false,
      applicationNotificationRequired: false,
      emailNotificationRequired: false,
      emailToCustomer: false,
      emailToServiceRep: false,
      customEmails: [],
      emailItems: [],
      search: null,
      isGetServiceTemplate: false,
      isUpdateserviceTemplate: false,
      isValidEmail: false,
      isEditing: false,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  watch: {
    customEmails(val, prev) {
      if (val.length === prev.length) return;
      this.customEmails = val.map((v) => {
        return v;
      });
    },
  },
  filters: {
    numberFormat: function (value) {
      if (value != "Quarterly" || value != "Monthly" || value != "yearly") {
        return Number(value).toLocaleString();
      }
    },
  },
  mounted() {
    if (this.$route.params.type == "add") {
      this.input = utils.getInputContent(
        "createserviceTemplateManagement",
        this.roles
      );
    } else {
      this.input = utils.getInputContent(
        "updateserviceTemplateManagement",
        this.roles
      );
    }
    if (this.$route.params.type == "edit") {
      this.getServiceTemplateDetailsById();
    }
  },
  methods: {
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    buildTriggerValue() {
      if (this.selectedTriggerType == "Calendar") {
        return this.selectedCalendarType;
      } else if (this.selectedTriggerType == "Hours") {
        return String(this.hours);
      }
      return String(this.miles);
    },
    buildTemplatePayload(id) {
      return {
        id: id,
        name: this.name,
        description: this.description,
        triggerType: this.selectedTriggerType,
        triggerValue: this.buildTriggerValue(),
        generateWorkOrderTicket: this.generateWorkOrderTicket,
        applicationNotificationRequired: this.applicationNotificationRequired,
        emailNotificationRequired: this.emailNotificationRequired,
        emailToCustomer: this.emailToCustomer,
        emailToServiceRep: this.emailToServiceRep,
        customEmailIds: this.customEmails.join(","),
      };
    },
    async createServicetemplate() {
      this.isCreateserviceTemplate = true;
      let payload = this.buildTemplatePayload("");
      try {
        let response = await telematicsService.createServiceTemplate(payload);
        if (response.isSuccess) {
          this.isCreateserviceTemplate = false;
          this.$toast.success("Service template created successfully");
          this.$router.push({ name: "Service Templates" });
        } else {
          this.isCreateserviceTemplate = false;
          this.$toast.error("Unable to create service template");
        }
      } catch (err) {
        console.log(err);
        this.isCreateserviceTemplate = false;
        this.$toast.error("Unable to create service template");
      }
    },
    async getServiceTemplateDetailsById() {
      this.isGetServiceTemplate = true;
      try {
        let response = await telematicsService.getServiceTemplateById(
          this.$route.params.id
        );
        if (response.isSuccess) {
          this.isGetServiceTemplate = false;
          let serviceResponse = response.data;
          this.name = serviceResponse.name;
          this.description = serviceResponse.description;
          this.selectedTriggerType = serviceResponse.triggerType;
          if (serviceResponse.triggerType == "Calendar") {
            this.selectedCalendarType = serviceResponse.triggerValue;
          } else if (serviceResponse.triggerType == "Hours") {
            this.hours = serviceResponse.triggerValue;
          } else {
            this.miles = serviceResponse.triggerValue;
          }
          this.generateWorkOrderTicket =
            serviceResponse.generateWorkOrderTicket;
          this.applicationNotificationRequired =
            serviceResponse.applicationNotificationRequired;
          this.emailNotificationRequired =
            serviceResponse.emailNotificationRequired;
          this.emailToCustomer = serviceResponse.emailToCustomer;
          this.emailToServiceRep = serviceResponse.emailToServiceRep;
          this.customEmails = serviceResponse.customEmailIds.split(",");
        } else {
          this.isGetServiceTemplate = false;
        }
      } catch (err) {
        this.isGetServiceTemplate = false;
        console.log(err);
      }
    },
    async updateServicetemplate() {
      this.isUpdateserviceTemplate = true;
      let payload = this.buildTemplatePayload(this.$route.params.id);
      try {
        let response = await telematicsService.updateServiceTemplate(
          this.$route.params.id,
          payload
        );
        if (response.isSuccess) {
          this.isUpdateserviceTemplate = false;
          this.$toast.success("Service template updated successfully");
          this.$router.push({ name: "Service Templates" });
        } else {
          this.isUpdateserviceTemplate = false;
          this.$toast.error("Unable to update service template");
        }
      } catch (err) {
        console.log(err);
        this.isUpdateserviceTemplate = false;
        this.$toast.error("Unable to update service template");
      }
    },
    ValidateEmail() {
      let tempEmails = [];
      if (this.customEmails.length > 0) {
        this.customEmails.filter((e) => {
          let emailRegX =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          let emailValid = emailRegX.test(e);
          tempEmails.push(emailValid);
          if (tempEmails.includes(false)) {
            this.isValidEmail = true;
          } else {
            this.isValidEmail = false;
          }
        });
      } else {
        this.isValidEmail = false;
      }
    },
    cancelUpdate(isEditing) {
      this.isEditing = !isEditing;
    },
    clearTemplate() {
      this.name = "";
      this.description = "";
      this.selectedTriggerType = "";
      this.selectedCalendarType = "";
      this.hours = "";
      this.miles = "";
      this.generateWorkOrderTicket = false;
      this.applicationNotificationRequired = false;
      this.emailNotificationRequired = false;
      this.emailToCustomer = false;
      this.emailToServiceRep = false;
      (this.customEmails = []), (this.emailItems = []);
      this.search = null;
    },
    updateRouterParams(){
      this.$router.push(`/service-template-management?filterVal=${this.$route.query.filterVal}&isFilter=${this.$route.query.isFilter}`);
    }
  },
};
